import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LinkApiOutput, LinkListItem, PermissionActions, User, ErrCode } from 'src/app/shared/models';
import { IFile } from 'src/sync';
import { LinkListService } from '../../../links/services/link-list.service';
import { UserService } from 'src/app/core/user.service';
import { DialogConfig } from '@material-library';
import { IDialogLinkManageFormData } from "./types";

@Component({
  selector: 'app-dialog-link',
  templateUrl: './dialog-link.component.html',
  styleUrls: ['./dialog-link.component.scss']
})
export class DialogLinkComponent implements OnInit {
  @Input() item: LinkListItem | IFile;
  
  @Input() openState: number;
  
  @Input() onLinkMutate?: Function;
  
  @Output() closeDialog = new EventEmitter<boolean>();
  
  public user: User;
  public link: LinkApiOutput;
  public initialized = false;
  public errcode: ErrCode;
  public dialogConfig: DialogConfig = {};
  public savedFormData: IDialogLinkManageFormData;
  
  constructor(
    private linkList: LinkListService,
    private userService: UserService
  ) {
  }
  
  public ngOnInit(): void {
    this.user = this.userService.getUser();
    if (!this.item.is_publink) {
      const shareLink = this.userService.checkPermission(PermissionActions.SHARE_LINKS);
      const shareLinkExpiry = this.userService.checkPermission(PermissionActions.SHARE_LINK_EXPIRY);
      const shareLinkPassword = this.userService.checkPermission(PermissionActions.SHARE_LINK_PASSWORD);
      if (shareLink && (shareLinkExpiry || shareLinkPassword)) {
        this.openState = 0;
      } else {
        this.openState = 5;
      }
      this.initialized = true;
    } else {
      if (this.openState == undefined) {
        this.openState = 1;
      }
      this.loadLinkData();
    }
  }
  
  private async loadLinkData(): Promise<void> {
    try {
      const data = await this.linkList.getLink(this.item.sync_id, this.item.name);
      if (data.success === 0) {
        this.handleLoadLinkFailure();
        return;
      }
      this.link = data;
      this.initialized = true;
    } catch (error) {
      this.handleLoadLinkFailure(error);
    }
  }
  
  private handleLoadLinkFailure(error?: any): void {
    this.initialized = false;
    this.openState = 99;
    this.dialogConfig.title = 'Share link';
    
    if (error) {
      const errorCode = ErrCode.fromException(error);
      this.errcode = errorCode.code === 1000 ? new ErrCode(1202) : errorCode;
      console.error('Error loading link:', error);
    } else {
      this.errcode = new ErrCode(1202);
    }
  }
  
  public saveFormData(data: IDialogLinkManageFormData): void {
    this.savedFormData = data;
  }
  
  public async onStateChange(state: number): Promise<void> {
    //TODO https://syncdev.atlassian.net/browse/UX-2380
    if ((this.openState == 0 || this.openState == 2 || this.openState == 5) && state == 1) {
      await this.loadLinkData();
    }
    this.openState = state;
  }
  
  public close(refresh: boolean) {
    this.closeDialog.emit(refresh);
  }
}
